export default {
    getModulesNormal(state) {
        if (state.modules.length) {
            return state.modules.filter(module => {
                return module.ForAdmin == 0 && module.Status == 1
            })
        }

        return []
    },
    getModulesAdmin(state) {
        if (state.modules.length) {
            return state.modules.filter(module => {
                return module.ForAdmin == 1 && module.Status == 1
            })
        }

        return []
    },
    getPointsConvertion(state) {
        return state.pointConvertions
    }
}